import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Flex } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

/**
 * Shared Form.Item with cancel and save buttons for drawer forms.
 * Used by settings general-condition, subscription-price, and supervision-prices drawers.
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.onClose - The function to call when the close button is clicked.
 * @returns {JSX.Element} The DrawerFormActions component.
 */
export const DrawerFormActions = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Form.Item wrapperCol={24}>
      <Flex gap={2} align="center" justify="end" style={{ marginTop: '16px' }}>
        <Button type="link" danger onClick={onClose}>
          {`${t('buttons.cancel')} `}
          <CloseOutlined />
        </Button>
        <Button type="add" htmlType="submit">
          {`${t('buttons.save')} `}
          <CheckOutlined />
        </Button>
      </Flex>
    </Form.Item>
  );
};

DrawerFormActions.propTypes = {
  onClose: PropTypes.func.isRequired
};
